import { useTransactionContext } from "../../../TransactionProvider";
import type { ColumnGetter } from "./types";

export const useTransaction = () => {
    const transaction = useTransactionContext();

    const getColumn: ColumnGetter<
        | 'updatedAt'
        | 'createdAt'
        | 'status'
        | 'fundStatus'
        | 'settlementStatus'
        | 'settlementStatusDateTime'
        | 'isSettled'
        | 'refId'
        | 'settledDate'
        | 'localTime'
        | 'reason'
    > = column => ({
        field: column,
        value: transaction[column]
    });

    return {
        getColumn
    };
};

export default useTransaction;
